<script setup lang="ts">
import { computed } from 'vue';
import { TEXT } from '../../configs/text';
import { ClassItemProps, ClassStatus, classStatusMap } from '../../types/class';
import Button from '../General/Button.vue';
import { useI18n } from 'petite-vue-i18n';
import { useClassStore } from '../../stores/class';

const classItem = defineProps<ClassItemProps>()

const contentName = computed(() => {
    return [classItem.subject_name, classItem.unit_name, classItem.lesson_name].filter(text => text).join(' - ')
})
const statusName = computed(() => classStatusMap[classItem.state] || '')

const classStatusColor = computed(() => {
    if (classItem.state === ClassStatus.finished) return 'danger';
    if (classItem.state === ClassStatus.on_going) return 'success';
    return 'gray'
})

const isSelectable = computed(() => {
    return classItem.state === ClassStatus.finished ? false : true
})

const { t } = useI18n()

const classStore = useClassStore()

function handleClassSelect() {
    if (!isSelectable.value) return;
    classStore.teacherClassId = classItem.id
    classStore.teacherClassSystem = classItem.system
}

</script>

<template>
    <div class="flex flex-col lg:grid grid-cols-4 lg:items-center gap-3 bg-white rounded-lg py-3 px-4 lg:py-7 lg:px-8"
        :class="!isSelectable ? 'cursor-not-allowed opacity-70' : ''">
        <div class="text-lg text-orange-600 font-bold">{{ name }}</div>
        <div>
            <div>{{ t(TEXT.content) }}</div>
            <div class="font-bold">{{ contentName }}</div>
        </div>
        <div>
            <div>{{ t(TEXT.schedule) }}</div>
            <div class="font-bold">{{ classStore.getClassScheduleFormat(classItem) }} </div>
        </div>
        <div>
            <Button type="outline" :color="classStatusColor" :shadow="false"
                class="lg:ml-auto w-full lg:w-auto min-w-40" @click="handleClassSelect" :disabled="!isSelectable">
                {{ t(statusName) }}
            </Button>
        </div>
    </div>
</template>

<style scoped></style>